import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ComponentData, TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'risk-multi-asset-deep-dive',
	templateUrl: './multi-asset-deep-dive.component.html',
	styleUrls: ['./multi-asset-deep-dive.component.scss']
})
export class MultiAssetDeepDiveComponent implements OnChanges, OnInit {

	@Input() public data: ComponentData;

	public asOfDate: string;
	public asOfDateSNP: string;
	public activeSumTab: TabData;
	public totalSumTab: TabData;
	public decompHeaderTab: TabData;
	public decompositionTabs: TabData[] = [];
	public subTitle: string;
	public title: string;

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		this.subTitle = this.contentService.get('MULTI_ASSET_DEEP_DIVE_SUBTITLE', 'MULTI_ASSET_DEEP_DIVE_SUBTITLE');
		this.title = this.contentService.get('MULTI_ASSET_DEEP_DIVE_TITLE', 'Multi-Asset Deep Dive');
	}

	public ngOnChanges(): void {
		if (this.data && this.data.success) {
			const asOfDateTab = this.data.getTabById('risk.asOfDate');
			this.asOfDate = get(asOfDateTab, 'displayConfig.visible') && get(asOfDateTab, 'tableData[0].cells[0][0].formattedValue');
			const asOfDateSNPTab = this.data.getTabById('risk.asOfDate.snp');
			this.asOfDateSNP = get(asOfDateSNPTab, 'displayConfig.visible') && get(asOfDateSNPTab, 'tableData[0].cells[0][0].formattedValue');
			this.activeSumTab = this.data.getTabById('multi.asset.active.risk.sum');
			this.totalSumTab = this.data.getTabById('multi.asset.risk.sum');
			this.decompHeaderTab = this.data.getTabById('multi.asset.risk.decomposition.header');
			const multiAssetActiveRiskDecompTab = this.data.getTabById('multi.asset.active.risk.decomposition');
			const multiAssetTotalRiskDecompTab = this.data.getTabById('multi.asset.risk.decomposition');
			if (multiAssetTotalRiskDecompTab) {
				this.decompositionTabs.push(multiAssetTotalRiskDecompTab);
			}
			if (multiAssetActiveRiskDecompTab) {
				this.decompositionTabs.push(multiAssetActiveRiskDecompTab);
			}
		}
	}
}
